var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_setup.isToday)?_c('span',[_vm._v(_vm._s(_vm.$t('WEBAPP_TODAY')))]):(_setup.isYesterday)?_c('span',[_vm._v(_vm._s(_vm.$t('WEBAPP_YESTERDAY')))]):_c('span',[_vm._v(_vm._s(_vm.$d(_setup._date, 'short')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }